module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_england_text_02.2a0c0387.jpg";